import React from 'react';
import Lottie from 'react-lottie';
import animationData from './lottie-loader.json';

const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }
};

export const CircularLoader = ({height = 360}) => {
    return <Lottie options={defaultOptions} height={height} width={360} />;
};
